import { render, staticRenderFns } from "./ManteCartaEnlace.vue?vue&type=template&id=05a2a896&"
import script from "./ManteCartaEnlace.vue?vue&type=script&lang=js&"
export * from "./ManteCartaEnlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports